export default __webpack_public_path__ + "static/chroma-v-2aa8641096af8ec840f84ba706546db3.jpg";